import * as z from 'zod';

export const DealLossMotiveSchema = z.object({
    "id": z.number(),
    "is_active": z.boolean(),
    "name": z.string()
});

export const DealLossMotivePartialSchema = DealLossMotiveSchema.partial();
export type DealLossMotivePartial = z.infer<typeof DealLossMotivePartialSchema>;
export type DealLossMotive = z.infer<typeof DealLossMotiveSchema>;

export function newDealLossMotive(data: unknown) {
    if (data === null || data === undefined) {
        throw new Error('Payload can\'t be null or undefined.');
    }

    if (typeof data !== 'object') {
        throw new Error('Payload has to be an object');
    }

    return {
        ...DealLossMotiveSchema.parse({...data})
    };
}

export function parseDealLossMotive(data: any, partial = false) {
    if (!partial) {
        return {
            ...DealLossMotiveSchema.parse(data)
        };
    }
    else if (data === null || data === undefined) {
        throw new Error('Payload can\'t be null or undefined.');
    }
    else if (typeof data !== 'object') {
        throw new Error('Payload has to be an object');
    }
    else if (Object.keys(data).length === 0) {
        throw new Error('Payload Object can\'t be null');
    }
    else {
        return {
            ...DealLossMotivePartialSchema.parse(data)
        };
    }
}
